export default () => ({
	id: null,
	agency: {},
	agencies: [],
	filter: null,
	error: null,
});
